import React from 'react'
import { Button, DialogueBox } from 'components/UIElements'
import { FALLBACK_STRINGS } from 'utils/constants'

const ConsentAwaitingAdditionalSignaturesView = ({
  strings,
  onButtonClick,
  humiIsabellaDisabled,
  isBlockingConsent
}) => {
  const heading = strings?.consent_awaiting_signatures_heading || FALLBACK_STRINGS.consent_awaiting_signatures_heading
  const message = strings?.consent_awaiting_signatures_message || FALLBACK_STRINGS.consent_awaiting_signatures_message
  const buttonText = strings?.got_it || FALLBACK_STRINGS.got_it

  return (
    <DialogueBox
      className='dialogue has-humi no-min-height'
      hasHumi={!humiIsabellaDisabled}>
      <h3>{heading}</h3>
      <p>{message}</p>
      {!isBlockingConsent ? (
        <Button
          primary
          className='start-consent-btn'
          content={buttonText}
          onClick={onButtonClick}
          type='button'
        />
      ) : null}
    </DialogueBox>
  )
}

export default ConsentAwaitingAdditionalSignaturesView
